import React from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaMusic } from "react-icons/fa";
import { useAuth } from "../contexts/AuthContext";
import "../styles/Header.css";

const Header = () => {
  const { isAuthenticated, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = React.useState(false);

  // Ripple effect for logout button
  const rippleRef = React.useRef(null);
  const createRipple = (event) => {
    const button = event.currentTarget;
    const circle = document.createElement("span");
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;
    circle.style.width = circle.style.height = `${diameter}px`;
    circle.style.left = `${event.clientX - button.getBoundingClientRect().left - radius}px`;
    circle.style.top = `${event.clientY - button.getBoundingClientRect().top - radius}px`;
    circle.classList.add("ripple-effect");
    const ripple = rippleRef.current;
    if (ripple) {
      ripple.innerHTML = "";
      ripple.appendChild(circle);
    }
    setTimeout(() => {
      if (ripple && ripple.firstChild) ripple.removeChild(ripple.firstChild);
    }, 600);
  };

  const isAuthPage = ["/login", "/signup"].includes(location.pathname);

  const handleLogout = () => {
    setIsLoggingOut(true);
    setTimeout(() => {
      logout();
      navigate("/"); // Always go to hero home page after logout
      setIsLoggingOut(false);
    }, 650); // Animation duration
  };



  return (
    <motion.header
      className="header"
      initial={{ opacity: 0, y: -50 }}
      animate={isLoggingOut ? { opacity: 0, y: -50 } : { opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="logo">
        <FaMusic className="logo-icon" />
        <h1>MoodTunes</h1>
      </div>
      <nav>
        <ul
          style={{
            display: "flex",
            gap: "1rem",
            listStyle: "none",
            alignItems: "center",
            margin: 0,
          }}
        >
          <li>
            <Link to="/" className="nav-link">
              Home
            </Link>
          </li>
          {isAuthenticated && !isAuthPage && (
            <>
              <li>
                <Link
                  to="/app"
                  className="nav-link"
                >
                  Fetch Music
                </Link>
              </li>
              <li>
                <button
                  className="nav-link logout-btn ripple-btn"
                  onClick={e => {
                    createRipple(e);
                    handleLogout();
                  }}
                  style={{ position: 'relative', overflow: 'hidden' }}
                >
                  Logout
                  <span className="ripple" ref={rippleRef} />
                </button>
              </li>
            </>
          )}
        </ul>
      </nav>
    </motion.header>
  );
};

export default Header;
